module.exports = __webpack_public_path__ + "static/img/8.c34347e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/eng/8.png
// module id = letu
// module chunks = 0